import { render, staticRenderFns } from "./TopMenuItem.vue?vue&type=template&id=fe6a3902&scoped=true"
import script from "./TopMenuItem.vue?vue&type=script&lang=js"
export * from "./TopMenuItem.vue?vue&type=script&lang=js"
import style0 from "./TopMenuItem.vue?vue&type=style&index=0&id=fe6a3902&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6a3902",
  null
  
)

export default component.exports